import { Box, Grid } from '@mui/material';
import SectionTitle from 'components/drawers/transaction-drawers/section-title/section-title.component';
import { useTranslation } from 'react-i18next';
import DetailsSingleSection from '../detail-single-section/detail-single-section.component';

const PaymentMethodSection = ({ transaction }) => {
  const { t } = useTranslation();
  const {
    paymentMethod: {
      lastFour = '',
      expirationMonth = null,
      expirationYear = null,
      type = '',
      cardBrand = '',
      billingZip = '',
    } = {},
  } = transaction ?? {};

  return (
    <Box>
      <SectionTitle
        title={t('drawer.transactionDrawer.paymentMethodSection.title')}
      />
      <Grid container spacing={1}>
        <DetailsSingleSection
          title={t('drawer.transactionDrawer.paymentMethodSection.number')}
          detail={`${t(
            'drawer.transactionDrawer.paymentMethod.endingIn',
          )} ${lastFour}`}
        />

        <DetailsSingleSection
          title={t('drawer.transactionDrawer.paymentMethodSection.expires')}
          detail={`${expirationMonth
            ?.toString()
            ?.padStart(2, '0')}/${expirationYear}`}
        />

        <DetailsSingleSection
          title={t('drawer.transactionDrawer.paymentMethodSection.type')}
          detail={`${cardBrand} ${type}`}
        />

        <DetailsSingleSection
          title={t('drawer.transactionDrawer.paymentMethodSection.postalCode')}
          detail={billingZip}
        />
      </Grid>
    </Box>
  );
};

export default PaymentMethodSection;
